export default __webpack_public_path__ + "static/media/ccslogo1.a716c296.jpeg";